import { MinusCircleIcon, DocumentDuplicateIcon, CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@heroui/react";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateBookingCommanWay, UpdateCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Input } from "components";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { InputTable } from "components/DataTable/InputTable";
import { TrainTrackingModal } from "components/TrainTrackingModal";
import { useFormik } from "formik";
import { debounce } from "lodash";
import moment from "moment";
import { any } from "prop-types";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import handleWheel from "utils/handleOnWheel";
import { get_file_url } from "utils/lib-utils";
import { AfDataType as ADT } from "utils/TableColumnData";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const MotherBagInScan: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mode = "add", data = {} } = (state || {}) as MotherBagState; // Check for existence and type assertion

  const [motherBagList, setMotherBagList] = useState<any>([]);
  const [motherbagGroupWiseList, setMotherbagGroupWiseList] = useState<any>({});
  const [selectedMotherbag, setSelectedMotherbag] = useState<any>(null);

  const [selectedViewMore, setSelectedViewMore] = useState<any>(null);

  const [awbDataList, setAwbDataList] = useState<any>([]);

  const [acceptedAwbNos, setAcceptedAwbNos] = useState<any>([]);
  const [awbScanVal, setAwbScanVal] = useState<any>("");
  const [mbagScanVal, setMbagScanVal] = useState<any>("");

  const [filterStartDt, setFilterStartDt] = useState<any>(moment().subtract(1, "day").startOf("day"));
  const [filterEndDt, setFilterEndDt] = useState<any>(moment().endOf("day"));

  const [motherbagStatusList, setMotherbagStatusList] = useState<any[]>([]);
  const [selectedMotherbagStatus, setSelectedMotherbagStatus] = useState<any>({});
  const [statusFilter, setStatusFilter] = useState<any>({ value: "", label: "All" });



  // Train tracking modal state
  const [trainTrackingModal, setTrainTrackingModal] = useState<{ isOpen: boolean; trainNo: string; defaultDate?: string }>({ isOpen: false, trainNo: "" });

  const [mySubbranch, setMySubbranch] = useState<any>(false);
  React.useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setMySubbranch(userD.state.user.subbranch);
    }
  }, []);

  React.useEffect(() => {
    console.log("mySubbranch", mySubbranch);
    if (mySubbranch) {
      setTimeout(refetchData, 200);
    }
  }, [mySubbranch]);

  const { refetch: mbag_status } = useQuery(["MbagStatusList"], () => GetCommanWay("/admin/mbag_status_list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data);
        setMotherbagStatusList(data.data);
      }
    },
  });

  useEffect(() => {
    if (selectedMotherbag) {
      console.log(selectedMotherbag);
      setTimeout((x) => {
        awbDataRefetch();
      }, 100);
    }
  }, [selectedMotherbag]);
  const { refetch: awbDataRefetch } = useQuery(
    ["AWBList"],
    () =>
      ListCommanWay(
        "/admin/awbdata/list",
        { mother_bag_id: selectedMotherbag, isInscan: true },
        {
          include: [],
          paginate: 1000,
        }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        console.log(data);
        if (data.status == "SUCCESS") {
          let mbagData: any = {};
          motherBagList.forEach((m) => {
            if (m.id == selectedMotherbag) {
              mbagData = m;
            }
          });
          let shortAwbs = mbagData.shortAwbs ? mbagData.shortAwbs.split(",") : [];

          let finalAwbs = data.data.data;
          if (shortAwbs.length) {
            finalAwbs = [];
            data.data.data.forEach((a) => {
              if (shortAwbs.includes(a.awb_no)) {
                finalAwbs.push(a);
              }
            });
          }
          setAwbDataList(finalAwbs);
        }
      },
    }
  );
  const { refetch: refetchData } = useQuery(
    ["MotherBagInApi"],
    () =>
      ListCommanWay(
        "/admin/mother_bag/list",
        {
          outscanDone: true,
          isInscan: true,
          delivery_subbranch: mySubbranch,
          $and: {
            $or: {
              $and: {
                createdAt: {
                  $gte: filterStartDt,
                  $lte: filterEndDt,
                },
              },
            },
          },
        },
        { paginate: 10000, include: ["_destination", "_subbranch", "_vendor", "_flight", "_airline"] }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          const sortedData = [...data.data.data].sort((a, b) => {
            const branchA = a._subbranch?.branch_name || '';
            const branchB = b._subbranch?.branch_name || '';
            return branchA.localeCompare(branchB);
          });

          setMotherBagList(sortedData);

          // Group by date then by origin
          const newData = sortedData.reduce((dateGroups, m) => {
            const date = moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY");
            const origin = m._subbranch?.branch_name || "Unknown";

            if (!dateGroups[date]) {
              dateGroups[date] = {};
            }
            if (!dateGroups[date][origin]) {
              dateGroups[date][origin] = [];
            }
            dateGroups[date][origin].push(m);
            return dateGroups;
          }, {});

          setMotherbagGroupWiseList(newData);

        }
      },
    }
  );

  const { mutate: addMotherbag_pod } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Status Changed", "success");
        resetForm();
        setAwbDataList([]);
        setSelectedMotherbag(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });

  const { mutate: ReleaseAwbNosMutate } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Airwaybill release successfully", "success");
        proceedToInScan();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Cannot Release Airwaybill Numbers. Try Again OR Contact Admin!", "error");
    },
  });
  const { mutate: InScanMotherbag } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag in-scan complete", "success");
        resetForm();
        setAwbDataList([]);
        setAcceptedAwbNos([]);
        setSelectedMotherbag(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag in-scan. Try Again OR Contact Admin!", "error");
    },
  });

  const proceedToInScan = () => {
    InScanMotherbag({
      url: "/admin/mother_bag/update/" + selectedMotherbag,
      data: {
        inScanPOD: true,
        inscanDone: true,
        selectedAwbs: acceptedAwbNos,
        status: "RECEIVED",
      },
    });
  };

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, resetForm, setFieldValue } =
    useFormik({
      validationSchema: object().shape({}),
      initialValues: {
        subbranch: { value: 0, label: "" },
      },
      onSubmit: async (values, { resetForm }) => {
        console.log("values", values);
        console.log("selcted mbag", selectedMotherbag);
        console.log("accpeted", acceptedAwbNos);
        if (!selectedMotherbag) {
          UseToast("Select Motherbag", "error");
          return;
        }
        if (acceptedAwbNos.length == 0) {
          UseToast("Scan atleast 1 Airwaybill", "error");
          return;
        }

        let awbToRelease: any[] = [];
        awbDataList.forEach((a) => {
          if (!acceptedAwbNos.includes(a.awb_no)) {
            awbToRelease.push(a.awb_no);
          }
        });

        if (awbToRelease.length > 0) {
          //alert("Cannnot Inscan! missing " + awbToRelease.length + " Airwaybill");
          //return;
          Swal.fire({
            title: "Are you Sure!",
            text: "you want to Declare as Short Piece: " + awbToRelease.join(", "),
            icon: "question",
            confirmButtonText: "Yes",
            showCancelButton: true,
          })
            .then((x) => {
              if (x.isConfirmed) {
                InScanMotherbag({
                  url: "/admin/mother_bag/update/" + selectedMotherbag,
                  data: {
                    shortAwbs: awbToRelease,
                    selectedAwbs: acceptedAwbNos,
                    inScanPOD: true,
                    inscanDone: true,
                    status: "RECEIVED",
                  },
                });
              } else {
                ////proceedToInScan();
              }
            })
            .catch((c) => {
              ////proceedToInScan();
            });
        } else {
          proceedToInScan();
        }
        //mutateUpdateMotherBag(data.id);
        //navigate("/mother_bag/list");
        return;
      },
    });

  const disableEnterKey = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
    }
  };

  const doShowRow = (m: any) => {
    switch (statusFilter.value) {
      case "":
        return true;
        break;
      case "pending":
        return m.outscanDone && !m.inscanDone ? true : false;
        break;
      case "received":
        return m.inscanDone ? true : false;
        break;
    }
  };

  const getModeSvg = (mode) => {
    switch (mode) {
      case "By Train":
        return (
          <svg className="bg-white p-1 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 24 24">
            \{" "}
            <path
              fill="#B8001F"
              d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
        );
      case "By Road":
        return (
          <svg className="bg-gray-400 p-2 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m0 0h48v48h-48z" fill="#fff" fillOpacity=".01" />
              <g stroke="#000" strokeWidth="4" transform="translate(6 5.091863)">
                <path d="m5 .90813664-5 35.99999996" />
                <path d="m36.9287415.90813664-4.9643707 35.95523776" transform="matrix(-1 0 0 1 67.928742 0)" />
                <path d="m18 .90813664v6" />
                <path d="m18 29.9081366v7" />
                <path d="m18 14.9081366v7" />
              </g>
            </g>
          </svg>
        );
      case "By Air":
        return (
          <div className="bg-black-900 p-2 rounded-full w-9 h-9">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
              <path
                fill="#08C2FF"
                d="m490.7 0c-21.3 0-42.7 0-53.3 10.7l-85.3 96h-330.8l-21.3 32 234.7 74.7-64 85.3h-96l-32 32 64 21.3v32c.7 11.5 10.7 21.3 21.3 21.3h32l21.3 64 32-32v-96l85.3-64 74.7 234.7 32-21.3v-330.7l96-85.3c10.7-10.7 10.7-32 10.7-53.4 0-10.6-10.7-21.3-21.3-21.3z"
              />
            </svg>
          </div>
        );
      default:
        return mode;
    }
  };

  return (
    <>
      <div className="flex items-center justify-between font-inter mt-2 mb-2 mx-4">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-black px-2 py-1 underline">Mother Bag In-Scan</h1>
        </div>
        <div className="flex flex-col items-center gap-1">
          <input
            type="text"
            value={mbagScanVal}
            className="w-56 px-3 py-1.5 rounded-lg border-2 border-orange-300 bg-orange-50 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none text-sm font-medium transition-all"
            placeholder="Scan motherbag code..."
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Tab") {
                e.preventDefault();
              }
            }}
            onInput={(e: any) => {
              const val = e.target.value;
              setMbagScanVal(val);
              const found = motherBagList.find((m) => m.mother_bag_code === val);
              if (found) {
                // Only allow selection if bag is not already fully received
                if (!(found.inscanDone && found.status != "SHORT")) {
                  setSelectedMotherbag(found.id);
                  resetForm();
                }
                setMbagScanVal("");
                setTimeout(() => {
                  document.getElementById("mbag-row-" + found.id)?.scrollIntoView({ behavior: "smooth", block: "center" });
                }, 100);
              }
            }}
          />
        </div>

        <div className="flex items-center justify-center gap-3">
          <AfDateRangePicker
            startDate={filterStartDt.format("YYYY-MM-DD")}
            endDate={filterEndDt.format("YYYY-MM-DD")}
            setStartDate={(e: any) => {
              setFilterStartDt(moment(e).startOf("day"));
            }}
            setEndDate={(e: any) => {
              setFilterEndDt(moment(e).endOf("day"));
            }}
            label="Date Range"
            page="motherbag"
          />

          <Button
            type="button"
            className="rounded-md px-3 py-2.5 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
            onClick={refetchData}
          >
            Search
          </Button>

          <div className="w-36">
            <Select
              className="flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block"
              options={[
                { value: "", label: "All" },
                { value: "pending", label: "Pending" },
                { value: "received", label: "Received" },
              ]}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e);
              }}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      >
        <div className="px-2 font-inter">
          {Object.entries(motherbagGroupWiseList).map(([date, origins]: any, i) => (
            <div key={date} className="mb-6 pt-2 pb-[1px] rounded-lg bg-[#DEDED1]">
              <div className="flex-1">
                <div className="mb-2 px-2">
                  <h4 className="text-lg font-bold">Date: {date}</h4>
                  <Table className="p-1 rounded-md" isCompact removeWrapper>
                    <TableHeader className="text-center bg-black-900 text-white">
                      <TableColumn className="bg-black-900 text-white py-2 px-2">-</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Added On</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Motherbag No</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Origin</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Destination</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Mode</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Total<br />Nos.</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Total<br />WT</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Status</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Slip</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Last Remark</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">...</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {Object.entries(origins).map(([origin, bags]: any, i2) => (
                        <>
                          {!statusFilter.value && (
                            <TableRow key={i + "blank-" + i2} className="bg-[#DEDED1]">
                              <TableCell className="text-xs p-0" colSpan={12}>&nbsp;</TableCell>
                            </TableRow>
                          )}

                          {bags.map(
                            (m) =>
                              doShowRow(m) && (
                                <TableRow
                                  key={i + "-" + m.id}
                                  id={"mbag-row-" + m.id}
                                  className={`border-t border-black-900_0c ${
                                    m.status == "SHORT"
                                      ? "bg-teal-600 text-white"
                                      : m.inscanDone
                                      ? "bg-green-500"
                                      : m.id == selectedMotherbag
                                      ? "bg-blue-200"
                                      : "bg-red-400"
                                  }`}
                                >
                                  <TableCell className="rounded-l-md">
                                    {m.inscanDone && m.status != "SHORT" ? (
                                      <span className="text-sm px-1">-</span>
                                    ) : m.id == selectedMotherbag ? (
                                      <span className="text-sm px-1 font-semibold">Selected</span>
                                    ) : (
                                      <div className="flex gap-1">
                                        <Button
                                          type="button"
                                          className="text-xs bg-primary text-white px-1.5 py-0.5"
                                          onClick={() => {
                                            setSelectedViewMore(selectedViewMore === m.id ? null : m.id);
                                          }}
                                        >
                                          View
                                        </Button>
                                        <Button
                                          type="button"
                                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10"
                                          onClick={() => {
                                            setSelectedMotherbag(m.id);
                                            resetForm();
                                          }}
                                        >
                                          Select
                                        </Button>
                                      </div>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    <div className="leading-none">
                                      <span className="whitespace-nowrap font-semibold">
                                        {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY")}
                                      </span>
                                      <br />
                                      <span className="whitespace-nowrap text-xs font-semibold">
                                        {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("HH:mm")}
                                      </span>
                                    </div>
                                  </TableCell>
                                  <TableCell className="px-2 whitespace-nowrap text-center">
                                    <button
                                      type="button"
                                      onClick={async () => {
                                        await navigator.clipboard.writeText(m.mother_bag_code || "-");
                                        UseToast("Copied!");
                                      }}
                                    >
                                      <DocumentDuplicateIcon className="h-5 -mb-1 mr-1" />
                                    </button>
                                    <span
                                      className="cursor-pointer hover:underline font-semibold font-opensans"
                                      onClick={() => {
                                        navigate("/mother_bag/add", {
                                          state: {
                                            mode: "view",
                                            data: m,
                                          },
                                        });
                                      }}
                                    >
                                      {m.mother_bag_code}
                                    </span>
                                  </TableCell>
                                  <TableCell className="text-center">{m._subbranch?.branch_name}</TableCell>
                                  <TableCell className="text-center">{m._destination?.city_name}</TableCell>
                                  <TableCell className="py-0 text-center">{getModeSvg(m.modeOfPkg)}</TableCell>
                                  <TableCell className="text-center">{m.totalNos}</TableCell>
                                  <TableCell className="text-center">{Number(m.realWeight || 0).toFixed(2)}</TableCell>
                                  <TableCell className="text-center">
                                    {m.status == "SHORT" ? "Short" : m.inscanDone ? "Received" : "Pending"}
                                  </TableCell>
                                  <TableCell className="text-center">
                                    {m?.VendorSlips?.length ? (
                                      <a
                                        href={(m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url)) || ""}
                                        target="_blank"
                                        className="inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 text-white border border-gray-200 hover:bg-opacity-60 focus:z-10"
                                      >
                                        Slip
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </TableCell>
                                  <TableCell>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</TableCell>
                                  <TableCell className="p-1 rounded-r-md">
                                    {m.mawbStatus?.train_no && (
                                      <button
                                        type="button"
                                        className="px-2 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700"
                                        onClick={() => setTrainTrackingModal({ isOpen: true, trainNo: m.mawbStatus.train_no, defaultDate: m.mawbStatus?.train_date })}
                                      >
                                        Live
                                      </button>
                                    )}
                                  </TableCell>
                                </TableRow>
                              )
                          )}
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          ))}

          {motherBagList.length === 0 && (
            <div className="text-center text-gray-500 py-10 text-sm">No motherbags found for the selected date range.</div>
          )}
        </div>

        {/* AWB Scan Section */}
        {selectedMotherbag && (
          <div className="mx-2 mt-4 font-inter">
            <div className="bg-white rounded-xl border p-4 shadow-sm">
              <div className="flex items-center justify-center gap-4 mb-4">
                <h3 className="text-lg font-bold whitespace-nowrap">Airwaybill Scan</h3>
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Scan AWB No:</label>
                  <input
                    type="text"
                    value={awbScanVal}
                    className="w-64 px-3 py-2 rounded-lg border-2 border-blue-300 bg-blue-50 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-sm font-medium transition-all"
                    placeholder="Scan or type AWB number..."
                    autoFocus
                    onKeyDown={disableEnterKey}
                    onInput={(e: any) => {
                    let found = false;
                    awbDataList.forEach((a) => {
                      if (a.awb_no == e.target.value) {
                        found = true;
                      }
                    });

                    if (found && !acceptedAwbNos.includes(e.target.value)) {
                      let obj = [...acceptedAwbNos];
                      obj.push(e.target.value);
                      setAcceptedAwbNos(obj);
                      setAwbScanVal("");
                    } else {
                      setAwbScanVal(e.target.value);
                    }
                  }}
                  />
                </div>
                <span className="text-sm text-gray-600 whitespace-nowrap">
                  Scanned: <strong className="text-green-600">{acceptedAwbNos.length}</strong> / {awbDataList.length}
                </span>
              </div>

              <div className="overflow-x-auto rounded-lg border">
                <Table isCompact removeWrapper>
                  <TableHeader>
                    <TableColumn className="bg-gray-800 text-white py-2 px-3">Status</TableColumn>
                    <TableColumn className="bg-gray-800 text-white px-3">AWB No</TableColumn>
                    <TableColumn className="bg-gray-800 text-white px-3">Destination</TableColumn>
                    <TableColumn className="bg-gray-800 text-white px-3">Weight</TableColumn>
                    <TableColumn className="bg-gray-800 text-white px-3">Consignee</TableColumn>
                    <TableColumn className="bg-gray-800 text-white px-3">Contact</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {awbDataList.map((e) => (
                      <TableRow
                        key={"awb-" + e.awb_no}
                        className={acceptedAwbNos.includes(e.awb_no) ? "bg-green-600 text-white" : "bg-white"}
                      >
                        <TableCell className="px-3">
                          {acceptedAwbNos.includes(e.awb_no) ? (
                            <CheckCircleIcon className="h-5 w-5 text-green-600" />
                          ) : (
                            <XCircleIcon className="h-5 w-5 text-gray-300" />
                          )}
                        </TableCell>
                        <TableCell className="px-3 font-semibold">{e.awb_no}</TableCell>
                        <TableCell className="px-3">{e.destination}</TableCell>
                        <TableCell className="px-3">{e.weight}</TableCell>
                        <TableCell className="px-3">{e.consignee}</TableCell>
                        <TableCell className="px-3">{e.contact_no}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>

              <div className="flex justify-end mt-4">
                <Button
                  type="submit"
                  className="rounded-md px-6 py-2.5 text-sm font-medium text-white bg-blue-800 hover:bg-blue-900 transition-colors"
                >
                  Accept In-Scan
                </Button>
              </div>
            </div>
          </div>
        )}
      </form>

      {/* Train Tracking Modal */}
      <TrainTrackingModal
        isOpen={trainTrackingModal.isOpen}
        onClose={() => setTrainTrackingModal({ isOpen: false, trainNo: "" })}
        trainNo={trainTrackingModal.trainNo}
        defaultDate={trainTrackingModal.defaultDate}
      />

    </>
  );
};

export default MotherBagInScan;
